///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BOMConfigPopupRoute, folderPopupRoute, projectPopupRoute, projectRoute } from './projects.route';
import { GtthProjectsComponent } from './projects.component';
import { GtthTreeControlsComponent } from './tree-controls/tree-controls.component';
import { GtthProjectsListComponent } from './projects-list/projects-list.component';
import { GtthFoldersListComponent } from './folders-list/folders-list.component';
import { GtthFolderDialogComponent, GtthFolderPopupComponent } from './dialogs/folder-dialog/folder-dialog.component';
import {
    GtthProjectsDeleteDialogComponent,
    GtthProjectsDeletePopupComponent
} from './dialogs/delete-project-dialog/delete-project-dialog.component';
import { GtthProjectControlsComponent } from './projects-list/project-control-btns/project-controls.component';
import { GtthProjectsEngComponent } from './projects-eng.component';
import { ProjectDragAndDropService } from './project-drag-and-drop.service';
import { GtthSharedModule } from '../shared/shared.module';
import { GtthTreeListSidebarComponent } from './tree-list-sidebar/tree-list-sidebar.component';
import {
    GtthLayersSettingsDialogComponent,
    GtthLayersSettingsPopupComponent
} from './dialogs/layers-settings-dialog/layers-settings-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSelectModule } from '@angular/material/select';
import { ProjectDialogGeneralTabComponent } from './dialogs/project-dialog/general-tab/project-dialog-general-tab.component';
import { ProjectDialogProductConfigTabComponent } from './dialogs/project-dialog/product-config-tab/project-dialog-product-config-tab.component';
import { ProjectDialogNwConfigTabComponent } from './dialogs/project-dialog/nw-config-tab/project-dialog-nw-config-tab.component';
import { ProjectDialogComponent, ProjectPopupComponent } from './dialogs/project-dialog/project-dialog.component';
import { NgOptimizedImage } from '@angular/common';
import {
    GtthProjectsFolderDeleteDialogComponent,
    GtthProjectsFolderDeletePopupComponent
} from './dialogs/delete-folder-dialog/delete-folder-dialog.component';
import { ProjectsViewStateService } from './projects-view-state.service';
import { FoldersTreeService } from './folders-tree/folders-tree.service';
import { ContextSensitiveHelpComponent } from '../shared/context-sensitive-help/ctx-sensitive-help.component';
import { TabsNavComponent } from '../shared/tabs-nav/tabs-nav.component';
import { HighlightTextComponent } from '../shared/global-components/highlight-text.component';
import {
    ProjectFilesImportDialogComponent,
    ProjectImportPopupComponent
} from './dialogs/project-files-import/project-files-import-dialog.component';

import { SuiTranslateDirective, SuiTranslatePipe } from '@siklu/sui-lib/localization';
import { SuiLoadingDirective } from '@siklu/sui-lib/components/loading';
import { SuiSvgIconComponent } from '@siklu/sui-lib/components/svg-icon';
import {
    SuiCheckboxControlComponent,
    SuiFileControlComponent,
    SuiRadioGroupControlComponent,
    SuiStringControlComponent,
    SuiToggleControlComponent,
    SuiTooltipDirective
} from '@siklu/sui-lib/infrastructure';
import { FileChooserComponent } from '../shared/sui-lib-customisations/sui-file-chooser/sui-winde-file-chooser.component';
import { FoldersTreeComponent } from './folders-tree/folders-tree.component';
import { ProjectDialogLayerGeneralPanelComponent } from './dialogs/project-dialog/product-config-tab/layer-general-panel/project-dialog-layer-general-panel.component';
import { SelectProductsComponent } from './dialogs/project-dialog/product-config-tab/select-products/select-products.component';
import { GtthDisableFormControlsDirective } from '../shared/directives/validation-directives/disable-form-controls.directive';

const ENTITY_STATES = [...projectRoute, ...folderPopupRoute, ...projectPopupRoute, ...BOMConfigPopupRoute];

@NgModule({
    imports: [
        GtthSharedModule,
        RouterModule.forChild(ENTITY_STATES),
        MatDialogModule,
        MatInputModule,
        MatAutocompleteModule,
        MatSelectModule,
        NgOptimizedImage,
        ContextSensitiveHelpComponent,
        TabsNavComponent,
        HighlightTextComponent,
        SuiTranslateDirective,
        SuiRadioGroupControlComponent,
        SuiToggleControlComponent,
        SuiTooltipDirective,
        SuiStringControlComponent,
        SuiFileControlComponent,
        SuiTranslatePipe,
        SuiLoadingDirective,
        SuiSvgIconComponent,
        SuiCheckboxControlComponent,
        FileChooserComponent,
        SuiTooltipDirective,
        FoldersTreeComponent,
        ProjectDialogLayerGeneralPanelComponent,
        ProjectDialogGeneralTabComponent,
        ProjectDialogNwConfigTabComponent,
        GtthDisableFormControlsDirective
    ],
    providers: [ProjectDragAndDropService, ProjectsViewStateService, FoldersTreeService],
    declarations: [
        GtthProjectsComponent,
        GtthTreeControlsComponent,
        GtthTreeListSidebarComponent,
        GtthProjectsListComponent,
        GtthFoldersListComponent,
        GtthFolderPopupComponent,
        GtthFolderDialogComponent,
        GtthProjectsFolderDeleteDialogComponent,
        GtthProjectsFolderDeletePopupComponent,
        GtthProjectsDeleteDialogComponent,
        GtthProjectsDeletePopupComponent,
        GtthProjectControlsComponent,
        ProjectDialogProductConfigTabComponent,
        ProjectPopupComponent,
        ProjectDialogComponent,
        GtthProjectsEngComponent,
        ProjectFilesImportDialogComponent,
        ProjectImportPopupComponent,
        GtthLayersSettingsDialogComponent,
        GtthLayersSettingsPopupComponent,
        SelectProductsComponent
    ],
    exports: [GtthProjectsComponent, GtthProjectsEngComponent, ProjectFilesImportDialogComponent]
})
export class GtthProjectsListModule {}
